import { useLocation } from 'react-router';
import { BrandedEmailEdition } from '@BrandedEmails/BrandedEmailEdition';
import { mapLocationToEmailType } from '@BrandedEmails/utils/mapLocationToEmailType';

export function BrandedEmail(): JSX.Element {
    const location = useLocation();
    const emailFromLocation = location.pathname.split('/').pop();
    const mappedEmailType = mapLocationToEmailType(emailFromLocation);

    return <>{mappedEmailType && <BrandedEmailEdition emailType={mappedEmailType} />}</>;
}
